import { Navigate } from "react-router-dom";
import rolePermissions from "./rolePermissions";

const ProtectedRoute = ({ permission, children }) => {
  const userRole = sessionStorage.getItem("role");
  const token = sessionStorage.getItem("newToken");

  const normalizedRole = String(userRole || "")
    .trim();

  const permissions = rolePermissions[normalizedRole] || [];

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (!permissions.includes(permission)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;